<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Import Buying Prices</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>

                    <v-col cols="4">
                        <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
                            dense></v-file-input>
                    </v-col>

                    <v-col cols="12">
                        <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
                            <v-icon left>mdi-upload</v-icon>Upload Stock
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    components: {},
    data: () => ({
        search: "",
        searchCustomers: null,
        selectedCustomer: {},
        customers: [],
        queryStore: null,
        stores: [],
        loader: false,
        excelFile: null,
        date: null
    }),
    watch: {
        searchCustomers(val) {
            if (val && val !== this.select && this.queryCustomers(val)) {
                this.queryCustomers(val);
            }
        }
    },
    methods: {
        setDate(myDate) {
            this.date = myDate;
        },
        queryCustomers(searchText) {
            const self = this;
            const url = "/customers/search";
            const data = {
                searchText: searchText
            };

            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        // if array length > 1
                        self.customers = res.ResponseData;
                    } else {
                        self.$store.commit("btnLoader", false);
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getBranches(id) {
            const self = this;
            var url = `/stores/customers/${id}`;
            this.$store
                .dispatch("get", url)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        uploadExcel() {
            var subscriber_id = localStorage.getItem("subscriber_id");

            const data = new FormData();
            data.append("documentData", this.excelFile);
            data.append("subscriber_id", parseInt(subscriber_id));
            this.$store.commit("btnLoader", true);
            const url = "/import-buying-prices";
            const self = this;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.$refs.snackbar.show(
                            "Stock imported successfully",
                            "green"
                        );
                        self.$store.commit("btnLoader", false);
                        self.excelFile = null;
                    } else {
                        self.$store.commit("btnLoader", false);
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
            // end
        },
    },
    created() {

    },
};
</script>